import React from 'react';

interface ChipProps {
  isSmall?: boolean;
}

const wrapperClass = (isSmall: boolean | undefined, bg: string): string =>
  `${bg} flex shrink-0 items-center justify-center rounded-full text-foreground ${isSmall ? 'size-5' : 'size-6'}`;

const innerSize = (isSmall: boolean | undefined): number => (isSmall ? 12 : 14);

export const RatingChip: React.FC<ChipProps> = ({ isSmall }) => (
  <span className={wrapperClass(isSmall, 'bg-yellow-soft')}>
    <svg
      width={innerSize(isSmall)}
      height={innerSize(isSmall)}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.88571 8.52856H1.65714V14.3429H5.88571V8.52856Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1143 5.35718H5.88571V14.3429H10.1143V5.35718Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3429 1.65717H10.1143V14.3429H14.3429V1.65717Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export const AsteriskChip: React.FC<ChipProps> = ({ isSmall }) => (
  <span className={wrapperClass(isSmall, 'bg-highlight-thistle')}>
    <svg
      width={innerSize(isSmall)}
      height={innerSize(isSmall)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.41797 14.543L11.0586 12.3945L8.63672 11.6914L9.05078 10.4102L11.457 11.332L11.3477 8.62109H12.707L12.582 11.3867L14.9492 10.4648L15.3633 11.7695L12.8945 12.4805L14.4961 14.582L13.3945 15.3789L11.9492 13.1133L10.5273 15.3164L9.41797 14.543Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

export const CommentChip: React.FC<ChipProps> = ({ isSmall }) => (
  <span className={wrapperClass(isSmall, 'bg-blue-soft')}>
    <svg
      width={isSmall ? 20 : 24}
      height={isSmall ? 20 : 24}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0427 20.0495C11.9354 20.4867 12.939 20.7322 14 20.7322C17.7181 20.7322 20.7321 17.7181 20.7321 14C20.7321 10.282 17.7181 7.26788 14 7.26788C10.2819 7.26788 7.26786 10.282 7.26786 14C7.26786 15.3802 7.6832 16.6634 8.39571 17.7314M11.0482 20.0486L11.0427 20.0495L7.26786 20.7322L8.39571 17.7314M8.39571 17.7314L8.39679 17.7286"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8929 12.4465H17.1071"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8929 15.5536H15.0357"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export const ScaleChip: React.FC<ChipProps> = ({ isSmall }) => (
  <span className={wrapperClass(isSmall, 'bg-red-soft')}>
    <svg
      width={isSmall ? 20 : 24}
      height={isSmall ? 20 : 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.0166 10.4214L16.6583 6.15976"
        stroke="currentColor"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8.21976V6.1102"
        stroke="currentColor"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.094 15.3413L8.60219 9.7347L6.11035 15.3413C6.11035 16.0172 6.37288 16.6654 6.8402 17.1434C7.3075 17.6213 7.94131 17.8898 8.60219 17.8898C9.26307 17.8898 9.89687 17.6213 10.3642 17.1434C10.8315 16.6654 11.094 16.0172 11.094 15.3413Z"
        stroke="currentColor"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.094 15.3413H6.11035"
        stroke="currentColor"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8899 12.333L15.3981 6.72635L12.9062 12.333C12.9062 13.0089 13.1688 13.6571 13.6361 14.135C14.1034 14.613 14.7373 14.8815 15.3981 14.8815C16.0589 14.8815 16.6928 14.613 17.16 14.135C17.6274 13.6571 17.8899 13.0089 17.8899 12.333Z"
        stroke="currentColor"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8899 12.333H12.9062"
        stroke="currentColor"
        strokeWidth="1.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
